import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { User } from 'lucide-react';
import { API_PREFIX, UPLOAD_PREFIX } from '../../config/appConfig';

const ChatHeader = ({ messages, currentUserId }) => {
  const [imageError, setImageError] = useState(false);
  
  const firstMessage = messages?.[0];
  if (!firstMessage) return null;

  const interlocutor = firstMessage.receiver_id === currentUserId
    ? firstMessage.sender
    : firstMessage.receiver;

  const isTherapist = interlocutor?.role === 'therapist';
  const profilePicture = interlocutor?.therapist?.profile_picture;
  const fullName = `${isTherapist ? 'Dott. ' : ''}${interlocutor?.first_name || ''} ${interlocutor?.last_name || ''}`.trim();
  const specialization = interlocutor?.therapist?.specialization;

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <header className="bg-white p-4 shadow-sm">
      <div className="flex items-center space-x-4">
        <div className="w-12 h-12 rounded-full flex items-center justify-center border-2 border-gray-200 overflow-hidden">
          {profilePicture && !imageError ? (
            <img
              src={`${UPLOAD_PREFIX}/storage/${profilePicture}`}
              alt={fullName}
              className="w-full h-full object-cover"
              onError={handleImageError}
            />
          ) : (
            <div className="w-full h-full bg-purple-100 flex items-center justify-center">
              <User className="w-6 h-6 text-purple-600" />
            </div>
          )}
        </div>
        
        <div>
          <h1 className="text-xl font-bold">
            {fullName || 'Utente'}
          </h1>
          {specialization && (
            <p className="text-sm text-gray-600">{specialization}</p>
          )}
        </div>
      </div>
    </header>
  );
};

ChatHeader.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      sender_id: PropTypes.number.isRequired,
      receiver_id: PropTypes.number.isRequired,
      sender: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        role: PropTypes.string,
        therapist: PropTypes.shape({
          profile_picture: PropTypes.string,
          specialization: PropTypes.string
        })
      }),
      receiver: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        role: PropTypes.string,
        therapist: PropTypes.shape({
          profile_picture: PropTypes.string,
          specialization: PropTypes.string
        })
      })
    })
  ).isRequired,
  currentUserId: PropTypes.number.isRequired
};

export default ChatHeader;